import React from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import {
  Group as UsersIcon,
  WarningAmber as AlertIcon,
  CalendarToday as CalendarIcon,
  VerifiedUser as ShieldIcon,
  ArrowOutward as ArrowOutwardIcon,
} from "@mui/icons-material";
import { getExpiryDays } from "../../../services/usersManagementService";
import StatCard from "./StatCard";

const GROWTH_BAR_HEIGHTS = [45, 60, 55, 80, 70, 95, 85];

const DashboardView = ({ stats, users, setActiveTab, onSelectUser }) => {
  const upcoming = users.filter(
    (u) => getExpiryDays(u.expiryDate) < 30 && u.status !== "Vencido"
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <StatCard
            title="Total Usuarios"
            value={stats.total}
            icon={<UsersIcon sx={{ color: "grey.600" }} />}
            subtitle="+2 este mes"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatCard
            title="Activos"
            value={stats.active}
            icon={<ShieldIcon sx={{ color: "success.main" }} />}
            color="success.main"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatCard
            title="En prueba"
            value={stats.trial}
            icon={<CalendarIcon sx={{ color: "info.main" }} />}
            color="info.main"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatCard
            title="Vencidos"
            value={stats.expired}
            icon={<AlertIcon sx={{ color: "error.main" }} />}
            color="error.main"
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ pt: 5 }}>
        <Grid item xs={12} md={8}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.200",
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="subtitle1" fontWeight={600}>
                Crecimiento reciente
              </Typography>
              <Button
                size="small"
                endIcon={<ArrowOutwardIcon fontSize="small" />}
                sx={{ textTransform: "none" }}
              >
                Ver reporte
              </Button>
            </Box>
            <Box
              sx={{
                height: 220,
                bgcolor: "grey.50",
                borderRadius: 2,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                p: 2,
                gap: 1.5,
              }}
            >
              {GROWTH_BAR_HEIGHTS.map((h, i) => (
                <Box
                  key={i}
                  sx={{
                    flex: 1,
                    bgcolor: "primary.main",
                    borderRadius: "4px 4px 0 0",
                    height: `${h}%`,
                    transition: "background-color 0.2s",
                    "&:hover": {
                      bgcolor: "primary.dark",
                    },
                  }}
                />
              ))}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.200",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Próximos vencimientos
            </Typography>
            <Stack spacing={1.5} sx={{ maxHeight: 260, overflowY: "auto", pr: 0.5 }}>
              {upcoming.map((u) => (
                <Paper
                  key={u.id}
                  variant="outlined"
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "grey.50" },
                  }}
                  onClick={() => {
                    setActiveTab("users");
                    onSelectUser?.(u);
                  }}
                >
                  <Box>
                    <Typography variant="body2" fontWeight={600}>
                      {u.company}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Vence en {getExpiryDays(u.expiryDate)} días
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor:
                        getExpiryDays(u.expiryDate) <= 7
                          ? "error.main"
                          : "warning.main",
                    }}
                  />
                </Paper>
              ))}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardView;
